import {
  Component,
  output,
  ChangeDetectionStrategy,
  ElementRef,
  viewChild,
  AfterViewInit,
} from '@angular/core';

@Component({
  selector: 'app-text-input-overlay',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <input
      #input
      type="text"
      placeholder="Type label, Enter to confirm, Esc to cancel"
      class="bg-white text-slate-900 placeholder-slate-400 border border-slate-300 shadow-lg px-2 py-1 rounded text-sm w-72"
      (keydown.enter)="onEnter()"
      (keydown.escape)="cancelled.emit()"
    />
  `,
})
export class TextInputOverlayComponent implements AfterViewInit {
  readonly inputRef = viewChild<ElementRef<HTMLInputElement>>('input');
  readonly confirmed = output<{ text: string; width: number; height: number }>();
  readonly cancelled = output<void>();

  ngAfterViewInit(): void {
    queueMicrotask(() => this.inputRef()?.nativeElement.focus());
  }

  onEnter(): void {
    const input = this.inputRef()?.nativeElement;
    if (!input) return;
    const text = input.value.trim();
    if (!text) {
      this.cancelled.emit();
      return;
    }
    const span = document.createElement('span');
    span.style.cssText =
      'visibility:hidden;position:absolute;font:14px sans-serif;white-space:nowrap;';
    span.textContent = text;
    document.body.appendChild(span);
    const rect = span.getBoundingClientRect();
    document.body.removeChild(span);
    const width = rect.width || text.length * 8;
    const height = rect.height || 16;
    this.confirmed.emit({ text, width, height });
  }
}
